import {Download} from 'lucide-react';
import {Button} from '@/shared/ui/button';

interface ExportButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
  title?: string;
  disabledTitle?: string;
}

const ExportButton = ({
  onClick,
  disabled = false,
  label = 'Export',
  title = 'Export',
  disabledTitle = 'No records to export',
}: ExportButtonProps) => (
  <Button
    variant="outline"
    size="sm"
    onClick={onClick}
    disabled={disabled}
    title={disabled ? disabledTitle : title}
  >
    <Download className="size-4 mr-2" />
    {label}
  </Button>
);

export default ExportButton;
